import { useComplianceCheck } from '@gateio/core-lib'

const useCompliance = (code = 'fiat_trade') => {
  const { complianceCheck } = useComplianceCheck({ enableRequest: true })
  const { menu } = complianceCheck || {}
  return {
    fiatTrate: menu?.includes(code),
  }
}

export default useCompliance
